/** Email helpers aligned with backend EmailStr (optional fields allowed empty). */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Required email — used on login / join. */
export function validateEmail(value: string): string | null {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return "Enter a valid email";
  if (!EMAIL_RE.test(trimmed)) return "Enter a valid email address";
  return null;
}

/**
 * Optional email — blank is OK; if filled, must look like a real address.
 * Prevents intake submit from sending garbage that EmailStr rejects with 422.
 */
export function validateOptionalEmail(value: string): string | null {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return null;
  if (!EMAIL_RE.test(trimmed)) return "Enter a valid email address";
  return null;
}
